import { render } from "./StrictConfirmDialog.vue?vue&type=template&id=37f3b9ee"
import script from "./StrictConfirmDialog.vue?vue&type=script&lang=js"
export * from "./StrictConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__